import { configureStore } from '@reduxjs/toolkit'
import ApiReducer from './Reducres/ApiReducer'
import UserReducer from './Reducres/UserReducer'
import TableReducer from './Reducres/TableReducer'
import RolesAndPermissionReducer from './Reducres/RoleReducer'
import AccountReducer from './Reducres/AccountReducer'
import BookReducer from './Reducres/BookReducer'

export const store = configureStore({
  reducer: {
    ApiReducer: ApiReducer,
    UserReducer: UserReducer,
    TableReducer: TableReducer,
    RolesAndPermissionReducer: RolesAndPermissionReducer,
    AccountReducer: AccountReducer,
    BookReducer: BookReducer,
  },
})